import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

export const Notification = ({ children, color = 'red', fullWidth }) => {
  const [isNotDelay, setDelay] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setDelay(true);
    }, 100);
  }, []);

  return (
    <NotificationWrapper
      isNotDelay={isNotDelay}
      color={color}
      fullWidth={fullWidth}
    >
      {children}
    </NotificationWrapper>
  );
};

const NotificationWrapper = styled.div`
  font-family: sans-serif;
  color: ${props => (props.color === 'green' ? 'black' : 'white')};
  position: fixed;
  background: ${props =>
    props.color === 'green'
      ? 'rgba(70,255,137,0.90);'
      : 'rgba(255, 70, 70, 0.9)'};
  padding: 30px;
  border-radius: 8px;
  right: 30px;
  top: 30px;
  left: ${props => (props.fullWidth ? '30px' : null)};
  max-width: ${props => (props.fullWidth ? '100%' : '200px')};
  transform: ${props =>
    props.isNotDelay ? 'translateY(0px)' : 'translateY(-200px)'};
  transition: all 300ms ease-in-out;
`;
